import * as React from 'react'
import { withRouter } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { IAppPropsWithRoute } from '../../common/types';
import SecondaryMenu from '../shared/SecondaryMenu';

import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from '@material-ui/core/styles';

import { TextField, FormHelperText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/Info';
import LinearProgress from '@material-ui/core/LinearProgress';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DeletePopUp from "../shared/DeletePopUp";

import '../../style/UserStyleSheet.css';

import { useForm, Controller } from "react-hook-form";
import { useState } from 'react';
import api from '../../store/api';

interface AddEditWardProps {
    wardId?: string | null
}

interface SelectItem extends React.Props<any> {
    text: string | undefined,
    value: string | undefined,
    selected: boolean,
    disabled: boolean | undefined
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    main: {
        //   padding: theme.spacing(0, 20, 0, 40)
    },
    mainTop: {
        //   padding: theme.spacing(5, 20, 0, 40)
    },
    heading: {
        fontSize: 36,
        fontWeight: 900,
        paddingBottom: 10,
        //   padding: theme.spacing(0, 0, 2, 0)
    },
    backText: {
        padding: 2,
        fontSize: '1.4464285714285716rem',
        color: "#02489D",
    },
    mainGrid: {
        width: '100%',
        //   padding: theme.spacing(0, 20, 0, 40)
    },
    textFieldRootOne: {
        width: 360,
    },
    textFieldRootTwo: {
        width: 200,
    },
    selectFieldThree: {
        width: 360,
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '40px'
    },
    textField: {
        backgroundColor: '#ECECEC',
        height: 30
    },
    textFieldLable: {
        fontSize: 15,
        color: '#949494',
        padding: theme.spacing(0, 0, 1, 0)
    },
    selectField: {
        backgroundColor: '#ECECEC',
        height: 40
    },
    formBtn: {
        // margin: theme.spacing(0, 1, 0, 1),
        width: '100px',
        height: '40px',
        marginRight: 20,
    },
    formLeft: {
        //margin: "40px 0px 40px 40px",
        //position: 'absolute',
        //bottom: 0,
        paddingLeft: 40,
        paddingBottom: 40,
        paddingTop: 40,
    },
    closeButton: {
        //position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dividerLine: {
        //position: 'absolute',
        width: '-webkit-fill-available',
        height: '1px',
        backgroundColor: '#979797',
    },
    alertRoot: {
        marginTop: 24
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    removeHover: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    deleteBtn: {
        float: 'right'
    }
}));

function AddEditWardWidget(props: AddEditWardProps): JSX.Element {
    const classes = useStyles();
    const history = useHistory();
    const wardId = props.wardId;
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    const [mainHeadingText, setMainHeadingText] = useState(wardId ? 'Edit Ward' : 'Add Ward');
    const [editWard, setEditWard] = useState(wardId ? true : false);
    const [editWardId, setEditWardId] = useState(wardId);
    const [locationList, setLocationList] = useState<SelectItem[]>([]);
    const [confirmationDialog, setConfirmationDialog] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");

    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        if (wardId)
            getEditWardData();
        else
            getAddWardData();
    }, []);

    // Return back to Wards page
    const backToWardList = () => {
        history.push({
            pathname: '/settings/wards'
        });
    };

    const HorizontalLine = (props: any) => {
        return (
            <hr
                style={{
                    height: 0,
                    borderTop: '1px solid #979797',
                }}
            />
        )
    }

    //call to get page data
    const getAddWardData = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");

        await api.getAddWardData('').then((_res) => {
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setLocationList(_res.data.model.locations);
            }
        }).catch((error) => {
            setErrorMessage('An error has happened while adding a new ward');
        });
    }

    //call to get edit ward data
    const getEditWardData = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");

        try {
            const _res = await api.getEditWardData('wardId=' + editWardId);
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setLocationList(_res.data.model.locations);

                let fields = ['name', 'shortName', 'locationId'];
                for (var field in fields) {
                    let fieldName = fields[field];
                    setValue(fieldName, _res.data.model[fieldName]);
                }
            }
        }
        catch (error) {
            setErrorMessage('An error has happened while editing a ward');
        }
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }

    const addOrUpdateWard = async (data: any): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        let _req: { [index: string]: any } = {
            name: data['name'],
            shortName: data['shortName'],
            locationId: data['locationId']
        }

        try {
            if (wardId === null || wardId === undefined || wardId === '') {
                const requestResponse = await api.addNewWard('', _req);
                if (!requestResponse.hasError && requestResponse.message !== null) {
                    setStatusMessage(requestResponse.message);
                    backToWardList();
                }
                else {
                    setErrorMessage(requestResponse.message ?? "");
                }
            }
            else {
                _req['wardId'] = wardId;
                const requestResponse = await api.updateWard('', _req);
                if (!requestResponse.hasError && requestResponse.message !== null) {
                    setStatusMessage(requestResponse.message);

                }
                else {
                    setErrorMessage(requestResponse.message ?? "");
                }
            }
        }
        catch (error) {
            setErrorMessage('An error has happened while updating a ward');
        }
    }

    const deleteWard = async (data: any): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");

        if (!wardId)
            return;

        let _req: { [index: string]: any } = {
            wardId: wardId,
            name: data['name'],
            shortName: data['shortName'],
            locationId: data['locationId'],
            deleted: true
        }

        try {
            const requestResponse = await api.updateWard('', _req);
            if (!requestResponse.hasError && requestResponse.message !== null)
                backToWardList();
            else
                setErrorMessage(requestResponse.message ?? "");
        }
        catch (error) {
            setErrorMessage(error);
        } finally {
            setConfirmationDialog(false);
        }
    }

    const StarIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" style={{ marginRight: 5 }}>
                <path id="_copy" data-name="* copy" d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z" fill="#f4b827" />
            </svg>
        );
    }

    // Back arrow icon
    const ArrowIcon = (props: any) => {
        return (
            <SvgIcon style={{ height: 20, width: 20 }}>
                <path d="M6.293,13.707l-6-6L.257,7.67h0L.242,7.652.235,7.644.226,7.634.217,7.622.212,7.615.2,7.6l0,0L.186,7.581l0,0L.172,7.56l0,0L.158,7.54l0,0L.146,7.52l0,0L.134,7.5l0-.005L.122,7.48l0-.008L.112,7.46.106,7.449l0-.009L.094,7.424l0,0L.083,7.4h0a1,1,0,0,1,0-.8v0l.008-.017,0-.009L.1,6.562l.007-.014,0-.006a1,1,0,0,1,.182-.25l6-6A1,1,0,0,1,7.707,1.707L3.414,6H17a1,1,0,0,1,0,2H3.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z" fill="#02489D" />
            </SvgIcon>
        );
    }

    return (
        <React.Fragment>
            <div style={{ display: 'flex', height: '100%', alignItems: 'stretch', flexGrow: 1, }}>

                <div style={{ height: '100%', display: 'flex', }}>
                    <SecondaryMenu selectedmenu='Wards' />
                </div>


                <form style={{ width: '100%' }} onSubmit={handleSubmit(addOrUpdateWard)} autoComplete="off" id="addWardForm">
                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 40 }}>



                            <Grid className={classes.mainGrid} container spacing={3}>
                                <Grid item xs={12}>
                                    <div className={classes.mainTop}>
                                        <IconButton className={classes.removeHover} onClick={backToWardList} aria-label="delete" size="small">
                                            <ArrowIcon /><span className={classes.backText}>Wards</span>
                                        </IconButton>
                                        {editWard ? <Button className={classes.deleteBtn} variant="contained" onClick={() => setConfirmationDialog(true)}>Delete</Button> : null}
                                    </div>


                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.main}>
                                        <div className={classes.heading}>
                                            {mainHeadingText}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className={classes.textFieldLable}><span><StarIcon /></span>NAME</div>
                                    <Controller
                                        control={control}
                                        as={<TextField classes={{ root: classes.textFieldRootOne }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                            error={errors.name}
                                            helperText={errors.name ? errors.name.message : ""} />}
                                        name='name'
                                        defaultValue=''
                                        rules={{
                                            required: "Name is required",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                </Grid>

                                <Grid item xs="auto">
                                    <div className={classes.textFieldLable}><span><StarIcon /></span>SHORT NAME</div>
                                    <Controller
                                        control={control}
                                        as={<TextField classes={{ root: classes.textFieldRootTwo }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                            error={errors.shortName}
                                            helperText={errors.shortName ? errors.shortName.message : ""} />}
                                        name='shortName'
                                        defaultValue=''
                                        rules={{
                                            required: "Short name is required",
                                            maxLength: {
                                                value: 10,
                                                message: "Max length is 10"
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs="auto" style={{ alignSelf: 'center' }}>
                                    Max 10 chars
                                </Grid>

                                <Grid item xs={12}>
                                    <div className={classes.textFieldLable}><span><StarIcon /></span>LOCATION</div>
                                    <Controller
                                        name='locationId'
                                        defaultValue=''
                                        control={control}
                                        render={({ onChange, onBlur, value, name }) => (
                                            <React.Fragment>
                                                <Select
                                                    name={name}
                                                    onChange={(e: any) => { onChange(e.target.value) }}
                                                    className={classes.selectFieldThree}
                                                    fullWidth={true}
                                                    value={value}
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    displayEmpty
                                                    defaultValue=''
                                                    variant="outlined">
                                                    <MenuItem key="None" value={''}>None</MenuItem >
                                                    {
                                                        editWard ?
                                                            locationList.filter(w => w.disabled == false || w.value == value).map(item => <MenuItem disabled={item.disabled} selected={item.selected}
                                                                key={item.value} value={item.value}>{item.text}</MenuItem>)
                                                            :
                                                            locationList.filter(w => w.disabled == false).map(item => <MenuItem selected={item.selected} key={item.value}
                                                                value={item.value}>{item.text}</MenuItem>)
                                                    }
                                                </Select>
                                                <FormHelperText className={classes.helpText}>{errors.locationId ? errors.locationId.message : ''}</FormHelperText>
                                            </React.Fragment>
                                        )}
                                        rules={{
                                            required: "Location is required",
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </div>
                        <div>
                            <div className={classes.main} style={{ paddingLeft: 40, paddingRight: 40, }}>
                                <div className={classes.headingAlert}>
                                    <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                        {errorMessage}
                                    </Alert>
                                    <Alert variant="filled" icon={<InfoIcon />} severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                                        {statusMessage}
                                    </Alert>
                                </div>
                            </div>

                            <div>
                                {loading ? <CreateLoadingLine /> : <HorizontalLine />}
                            </div>

                            <div className={classes.formLeft}>
                                <Button disabled={formState.isSubmitting} className={classes.formBtn} variant="contained" color="primary" type='submit'>Save</Button>
                                <Button className={classes.formBtn} variant="contained" onClick={backToWardList}>Cancel</Button>
                            </div>

                        </div>
                    </div>
                </form>

            </div>
            <DeletePopUp 
                isDialogOpen={confirmationDialog} 
                onCancel={() => setConfirmationDialog(false)} 
                onDo={deleteWard} 
                title="Delete ward"
                recordName="ward" 
            />
         </React.Fragment>
    );
}

export default React.memo(AddEditWardWidget);